/**
 * @desc getItemList
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export type Response = defs.omsFlow.ResponseDto<Array<defs.omsFlow.AsRefundOrderItemResponseDto>>;
export function request(refundNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/asRefundOrderItem/${refundNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
